import { render, staticRenderFns } from "./nav-back.vue?vue&type=template&id=2dac8bf8"
import script from "./nav-back.vue?vue&type=script&lang=js"
export * from "./nav-back.vue?vue&type=script&lang=js"
import style0 from "./nav-back.vue?vue&type=style&index=0&id=2dac8bf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports